module.exports = __webpack_public_path__ + "img/reference-form-header.1670579c.png";